module.exports = __webpack_public_path__ + "4d85b12bd9361a8a4ddb31e8a02c8d84.png";


/*****************
 ** WEBPACK FOOTER
 ** ./blog/graphql-shopping-cart-api/graphql-shopping-cart.png
 ** module id = 340
 ** module chunks = 0
 **/